import { render, staticRenderFns } from "./table-budget-fr.vue?vue&type=template&id=1b5d20a9&scoped=true&"
import script from "./table-budget-fr.vue?vue&type=script&lang=ts&"
export * from "./table-budget-fr.vue?vue&type=script&lang=ts&"
import style0 from "./table-budget-fr.vue?vue&type=style&index=0&id=1b5d20a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5d20a9",
  null
  
)

export default component.exports